// Steirerhaus deployment: the backend is served under /restapi/api (not the
// shared /api), so this overrides the generic environment.prod.ts basePath.
// Mirrors the dev proxy target in proxy.conf.prod.json.
import { AuthenticationMode } from '@softline/auth';

export const environment = {
  production: true,
  recaptchaSiteKey: '6LcgmFkUAAAAACcqE7VX5ft4linzJlEafUAGl3d8',
  authentication: 'jwt' as AuthenticationMode,
  connection: {
    name: 'SoftApps',
    host: location.protocol + '//' + location.hostname,
    port: Number(location.port),
    basePath: '/restapi/api',
  },
};
